import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getClaims({ status, page, pharmacy, rut, claimId, claimType, trxId }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/claim/search-by-status/${Enviroment.LANGUAGE}/page/${page}`,
			params: { rut: rut, status: status, claim_id: claimId, type: claimType, pharmacy: pharmacy, trx_id: trxId },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getClaimByMongoId(id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/claim/by-id/${id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getClaimById(claim_id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/claim/${claim_id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async resendEmail(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_EMAIL}/${Enviroment.LANGUAGE}/complaint-book`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async sendEmailClosed(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_EMAIL}/${Enviroment.LANGUAGE}/complaint-book-closed`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async updateClaim(id, body, token) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.API_PHARMACY}/claim/update/only-pharmacy/${id}`,
			headers: {
				Authorization: `Bearer ${token}`,
			},
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
